import styles from "./MinMaxPrice.module.css"
import PriceInputs from "./PriceInputs"
const MinMaxPrice = () => {
  return (
      <div className={styles.min_max_container}>
          <PriceInputs field_id="base" title="Min Price" percentageDifference={-15} />
          <PriceInputs field_id="quote" title="Max Price" percentageDifference={ 15}/>
      </div>
  )
}

export default MinMaxPrice